/**
 * gift-cart-tier.js
 * Gère l'ajout et le retrait automatique du cadeau offert dès le palier 49€
 */

((document) => {
    'use strict';

    let isUpdating = false;
    let debounceTimer = null;
    let celebratedTier = sessionStorage.getItem('kea_celebrated_tier') === 'true';

    /**
     * Animation de Confettis ultra-légère en Canvas HTML5
     */
    function launchConfetti() {
        try {
            if (document.getElementById('kea-confetti-canvas')) return;

            const canvas = document.createElement('canvas');
            canvas.id = 'kea-confetti-canvas';
            canvas.style.position = 'fixed';
            canvas.style.top = '0';
            canvas.style.left = '0';
            canvas.style.width = '100vw';
            canvas.style.height = '100vh';
            canvas.style.pointerEvents = 'none';
            canvas.style.zIndex = '999999';
            document.body.appendChild(canvas);

            const ctx = canvas.getContext('2d');
            const width = canvas.width = window.innerWidth;
            const height = canvas.height = window.innerHeight;

            const colors = ['#10b981', '#ec4899', '#8b5cf6', '#f59e0b', '#3b82f6', '#ef4444', '#14b8a6'];
            const particles = [];
            const particleCount = 60;

            for (let i = 0; i < particleCount; i++) {
                particles.push({
                    x: Math.random() * width,
                    y: Math.random() * height * 0.3 - height * 0.1,
                    w: Math.random() * 10 + 5,
                    h: Math.random() * 6 + 4,
                    vx: (Math.random() - 0.5) * 6,
                    vy: Math.random() * 4 + 3,
                    rotation: Math.random() * 360,
                    rotationSpeed: (Math.random() - 0.5) * 10,
                    color: colors[Math.floor(Math.random() * colors.length)],
                    opacity: 1,
                    decay: Math.random() * 0.015 + 0.008
                });
            }

            let animationFrame;
            const startTime = Date.now();

            function render() {
                const elapsed = Date.now() - startTime;
                ctx.clearRect(0, 0, width, height);

                let activeCount = 0;

                particles.forEach(p => {
                    if (p.opacity <= 0) return;
                    activeCount++;

                    p.x += p.vx;
                    p.y += p.vy;
                    p.rotation += p.rotationSpeed;
                    if (elapsed > 1000) {
                        p.opacity -= p.decay;
                    }

                    ctx.save();
                    ctx.translate(p.x, p.y);
                    ctx.rotate((p.rotation * Math.PI) / 180);
                    ctx.globalAlpha = Math.max(0, p.opacity);
                    ctx.fillStyle = p.color;
                    ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
                    ctx.restore();
                });

                if (activeCount > 0 && elapsed < 2500) {
                    animationFrame = requestAnimationFrame(render);
                } else {
                    cancelAnimationFrame(animationFrame);
                    if (canvas.parentNode) {
                        canvas.parentNode.removeChild(canvas);
                    }
                }
            }

            render();
        } catch (e) {
            console.error('[confetti]', e);
        }
    }

    /**
     * Lit les paramètres du snippet depuis le wrapper HTML
     */
    function getConfig() {
        const wrapper = document.querySelector('.cart-tier-progress-wrapper');
        if (!wrapper) return null;

        const threshold = parseInt(wrapper.getAttribute('data-threshold') || '4900', 10);
        const giftId = parseInt(wrapper.getAttribute('data-gift-id') || '0', 10);

        if (!giftId || giftId <= 0 || isNaN(giftId)) {
            return null;
        }

        return { threshold, giftId };
    }

    /**
     * Identifie si un article du panier est un cadeau offert
     */
    function isItemGift(item, giftId) {
        if (!item) return false;
        const matchesId = (item.variant_id == giftId || item.id == giftId);
        const hasGiftProp = item.properties && (
            item.properties._is_gift === 'true' ||
            item.properties._is_gift === true ||
            item.properties._gift_choice === 'true'
        );
        return matchesId || hasGiftProp;
    }

    /**
     * Calcule le sous-total du panier en excluant TOUS les cadeaux
     */
    function getNonGiftSubtotal(cart, giftId) {
        return (cart.items || []).reduce((sum, item) => {
            const isGift = isItemGift(item, giftId) ||
                (item.properties && (item.properties._is_gift === 'true' || item.properties._source === 'coupon_gift'));
            if (isGift) return sum;
            return sum + (item.final_line_price || 0);
        }, 0);
    }

    /**
     * Rafraîchit le drawer mini-cart via Section Rendering API
     */
    function refreshDrawer() {
        const drawerEl = document.querySelector('cart-drawer');
        if (drawerEl) {
            const sectionId = drawerEl.getAttribute('section') || 'mini-cart';
            fetch(`${window.themeVariables.routes.cartUrl}?section_id=${sectionId}`)
                .then(res => res.text())
                .then(html => {
                    const fakeDiv = document.createElement('div');
                    fakeDiv.innerHTML = html;
                    const newContent = fakeDiv.querySelector('cart-drawer');
                    if (newContent && drawerEl) {
                        drawerEl.innerHTML = newContent.innerHTML;
                    }
                })
                .catch(() => {});
        }
    }

    /**
     * Vérifie et applique l'ajout/retrait du cadeau
     */
    async function checkGift(cart) {
        if (!cart || isUpdating) return;

        const config = getConfig();
        if (!config) return;

        const { threshold, giftId } = config;
        const total = getNonGiftSubtotal(cart, giftId);
        const allItems = cart.items || [];

        // Identifier TOUS les cadeaux : par ID ou par propriété _is_gift
        const matchingGifts = allItems.filter(item => (item.variant_id == giftId || item.id == giftId));
        const orphanGifts = allItems.filter(item =>
            item.properties && item.properties._is_gift === 'true' &&
            item.variant_id != giftId && item.id != giftId
        );

        let actionNeeded = false;
        const itemsToAdd = [];
        const updates = {};

        if (total >= threshold) {
            // === PALIER ATTEINT : LE CADEAU DOIT ÊTRE PRÉSENT AVEC QTÉ = 1 ===
            if (!celebratedTier) {
                celebratedTier = true;
                sessionStorage.setItem('kea_celebrated_tier', 'true');
                setTimeout(launchConfetti, 200);
            }

            // Supprimer d'éventuels anciens cadeaux obsolètes
            for (const orphan of orphanGifts) {
                updates[orphan.key] = 0;
                actionNeeded = true;
            }

            if (matchingGifts.length === 0) {
                // Cadeau absent -> on l'ajoute
                itemsToAdd.push({
                    id: giftId,
                    quantity: 1,
                    properties: { '_is_gift': 'true' }
                });
                actionNeeded = true;
            } else if (matchingGifts.length > 1 || matchingGifts[0].quantity !== 1) {
                // Cadeau en quantité erronée -> fixer à 1
                updates[matchingGifts[0].key] = 1;
                for (let i = 1; i < matchingGifts.length; i++) {
                    updates[matchingGifts[i].key] = 0;
                }
                actionNeeded = true;
            }

        } else {
            // === EN DESSOUS DU PALIER : RETIRER TOUS LES CADEAUX ===
            sessionStorage.removeItem('kea_celebrated_tier');
            celebratedTier = false;

            // Retirer tous les cadeaux qui matchent par ID (peu importe les propriétés)
            for (const g of matchingGifts) {
                updates[g.key] = 0;
                actionNeeded = true;
            }
            // Retirer aussi les orphelins
            for (const orphan of orphanGifts) {
                updates[orphan.key] = 0;
                actionNeeded = true;
            }
        }

        // SI AUCUNE ACTION REQUISE, SORTIR
        if (!actionNeeded) {
            return;
        }

        // Verrouiller
        isUpdating = true;

        try {
            // 1. Mettre à jour les quantités / suppressions
            if (Object.keys(updates).length > 0) {
                await fetch('/cart/update.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ updates })
                });
            }

            // 2. Ajouter le cadeau si nécessaire
            if (itemsToAdd.length > 0) {
                await fetch('/cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ items: itemsToAdd })
                });
            }

            // 3. Rafraîchir le drawer immédiatement avec les vraies données
            refreshDrawer();

            // 4. Second rafraîchissement après que le thème ait fini ses propres mises à jour (600ms+)
            setTimeout(() => {
                refreshDrawer();
                // 5. Déverrouiller et re-vérifier une dernière fois
                setTimeout(() => {
                    isUpdating = false;
                    // Dernière vérification de sécurité
                    fetch('/cart.js')
                        .then(res => res.json())
                        .then(c => checkGift(c))
                        .catch(() => { isUpdating = false; });
                }, 500);
            }, 800);

        } catch (err) {
            console.error('[gift-tier] Erreur:', err);
            isUpdating = false;
        }
    }

    /**
     * Récupère les données fraîches du panier et vérifie le cadeau
     * Debounce à 800ms pour attendre que le thème finisse ses propres mises à jour HTML
     */
    function scheduleCheck() {
        if (isUpdating) return;
        clearTimeout(debounceTimer);
        debounceTimer = setTimeout(() => {
            if (isUpdating) return;
            fetch('/cart.js')
                .then(res => res.json())
                .then(c => checkGift(c))
                .catch(() => {});
        }, 800);
    }

    // Écouter TOUS les événements du panier Focal
    document.documentElement.addEventListener('cart:updated', scheduleCheck);
    document.documentElement.addEventListener('cart:refresh', scheduleCheck);
    document.documentElement.addEventListener('variant:added', scheduleCheck);
    document.addEventListener('line-item-quantity:change:end', scheduleCheck);

    /**
     * Initialisation au chargement de la page
     */
    function init() {
        if (getConfig()) {
            fetch('/cart.js')
                .then(res => res.json())
                .then(cart => checkGift(cart))
                .catch(() => {});
        }
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        setTimeout(init, 300);
    }

})(document);